<template lang="pug">
v-window(v-model="window")
  v-window-item
    p Вы хотите подписать {{ selected.length }} удостоверений
    p.warning--text Это может занять некоторое время
    v-btn(color="primary" depressed @click="startSign") Продолжить
  v-window-item.px-2
    v-expansion-panels(flat)
      v-expansion-panel
        v-expansion-panel-header.pa-0
          v-list-item.mx-n2.pl-2.sdo-radius(link)
            v-list-item-action.mr-3
              v-progress-circular(
                v-if="loading"
                indeterminate
                color="primary"
              )
              v-icon(v-else color="success") mdi-check
            v-list-item-content
              .text-body-2 {{ loading ? 'Загрузка документов' : 'Документы загружены'}}
              .caption(v-if="!loading") Загружено {{ documents.length }} документов
            v-list-item-action(
              v-if="!loading"
            ): v-icon mdi-eye
          template(#actions)
            span
        v-expansion-panel-content.mx-n2
          v-list-item(
            v-for="i in documents" :key="i.id"
            @click="getDocument(i.is)"
        ).mx-n4.px-4.sdo-radius.py-1
            v-list-item-icon.mr-4: v-icon(color="primary") mdi-file-download
            v-list-item-content.primary--text
              strong {{ `${i.diploma.serial} ${i.diploma.number}` }}
            v-list-item-action: v-icon mdi-arrow-right
    file-sign.mt-4(
      :files="documents"
      :disabled="loading"
      :successCallback="signDocument"
    )
</template>
<script>
import FileSign from '@/components/FileSignature/index.vue';

export default {

  components: {
    FileSign,
  },
  props: {
    selected: { type: Array, required: true },
    unSelected: { type: Array, default: () => [] },
  },
  data() {
    return {
      window: 0,
      documents: [],
      items: [],
      loading: true,
    };
  },
  methods: {
    getDocument(document) {
      console.log(document);
      const blob = new Blob([document], { type: 'application/pdf' });
      const objectUrl = URL.createObjectURL(blob);
      window.open(objectUrl);
    },
    async startSign() {
      this.window = 1;
      const response = await this.$api.diploma.getDiplomas({
        'search[status]': 3,
        'per-page': -1,
      });
      const items = response.data.data.filter(
        ({ id }) => this.selected.includes(id) && !this.unSelected.includes(id),
      );
      const promises = items.map(async (item) => {
        const res = await this.$api.diploma.orgDownloadDiploma(item.id);
        return { is: res.data, diploma: item };
      });
      this.documents = await Promise.all(promises);
      // this.documents = result.map(({ file, diploma }) => ({ is: data }));
      this.loading = false;
    },
    async signDocument(val) {
      const promises = val.map((s) => s.validate());
      await Promise.all(promises);
      const payload = val.map((
        {
          hash,
          signature,
          signData: {
            commonName, serialNumber, validFromDate, validToDate, issuerName, title,
          },
        },
        idx,
      ) => ({
        id: this.documents[idx].diploma.id,
        hash,
        position: title,
        sign_hash: signature,
        common_name: commonName,
        issuer_name: issuerName,
        serial_number: serialNumber,
        valid_from_at: validFromDate,
        valid_to_at: validToDate,
      }));
      await this.$api.diploma.signMassDiploma({ diplomas: payload });
      this.$emit('sign');
    },
  },
};
</script>
